import { FC } from "react";
import ReactTooltip from "react-tooltip";
import { useNavigate } from 'react-router-dom'

const HeaderGrid: FC<hederGridProps> = (props) => {
    const navigate = useNavigate()
    return (
      <>
        <div className='input-group'>
          <div className='container'>
            <div className='row'>
              <div className='col col-info'>
                <div className='item-info'>
                  <a
                    className='btn btn-secondary btn-sm'
                    data-tip
                    data-for='i-minuta'
                    onClick={props.onPrintMinuta}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='30'
                      height='30'
                      fill='#2A2889'
                      className='bi bi-file-earmark-pdf'
                      viewBox='0 0 16 16'
                    >
                      <path d='M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z' />
                      <path d='M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z' />
                    </svg>
                  </a>
                  <ReactTooltip id='i-minuta' place='top' type='error' effect='solid'>
                    Imprimir Minuta
                  </ReactTooltip>
                  <a className='' href=''>
                    {/* <i className="bi bi-filetype-pdf"></i> */}
                  </a>
                  <a
                    className='btn btn-secondary btn-sm'
                    data-tip
                    data-for='i-minuta-cliente'
                    onClick={props.onPrintMinutaCliente}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='30'
                      height='30'
                      fill='#2A2889'
                      className='bi bi-filetype-pdf'
                      viewBox='0 0 16 16'
                    >
                      <path
                        fillRule='evenodd'
                        d='M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z'
                      />
                    </svg>
                  </a>
                  <ReactTooltip id='i-minuta-cliente' place='top' type='error' effect='solid'>
                    Imprimir Minuta Cliente
                  </ReactTooltip>

                  <a
                    className='btn btn-secondary btn-sm'
                    data-tip
                    data-for='e-minuta'
                    onClick={props.onExportMinuta}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='30'
                      height='30'
                      fill='#2A2889'
                      className='bi bi-file-earmark-ruled'
                      viewBox='0 0 16 16'
                    >
                      <path d='M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 0 1-1-1v-1zm3 2v-2h7v1a1 1 0 0 1-1 1H6zm7-3H6v-2h7v2z' />
                    </svg>
                  </a>
                  <ReactTooltip id='e-minuta' place='top' type='success' effect='solid'>
                    Exportar Minuta
                  </ReactTooltip>

                  <a
                    className='btn btn-secondary btn-sm'
                    data-tip
                    data-for='e-minuta-cliente'
                    onClick={props.onExportMinutaCliente}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='30'
                      height='30'
                      fill='#2A2889'
                      className='bi bi-file-earmark-excel'
                      viewBox='0 0 16 16'
                    >
                      <path d='M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z' />
                      <path d='M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z' />
                    </svg>
                  </a>
                  <ReactTooltip id='e-minuta-cliente' place='top' type='success' effect='solid'>
                    Exportar Minuta Cliente
                  </ReactTooltip>

                  <a
                    className='btn btn-secondary btn-sm'
                    data-tip
                    data-for='deshacer2'
                    onClick={props.back}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='30'
                      height='30'
                      fill='#2A2889'
                      className='bi bi-arrow-counterclockwise'
                      viewBox='0 0 16 16'
                    >
                      <path
                        fillRule='evenodd'
                        d='M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z'
                      />
                      <path d='M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z' />
                    </svg>
                  </a>
                  <ReactTooltip id='deshacer2' place='top' type='warning' effect='solid'>
                    Deshacer
                  </ReactTooltip>

                  <a
                    className='btn btn-secondary btn-sm'
                    data-tip
                    data-for='deshacer-todo2'
                    onClick={props.backAll}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='30'
                      height='30'
                      fill='#2A2889'
                      className='bi bi-trash3'
                      viewBox='0 0 16 16'
                    >
                      <path d='M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z' />
                    </svg>
                  </a>
                  <ReactTooltip id='deshacer-todo2' place='top' type='dark' effect='solid'>
                    Deshacer Todo
                  </ReactTooltip>

                  <a
                    className='btn btn-secondary btn-sm'
                    data-tip
                    data-for='guardar2'
                    onClick={props.onSave}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='30'
                      height='30'
                      fill='#2A2889'
                      className='bi bi-clipboard2-check'
                      viewBox='0 0 16 16'
                    >
                      <path d='M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5h3Z' />
                      <path d='M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12Z' />
                      <path d='M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3Z' />
                    </svg>
                  </a>
                  <ReactTooltip id='guardar2' place='top' type='info' effect='solid'>
                    Guardar
                  </ReactTooltip>

                  <a
                    className='btn btn-secondary btn-sm'
                    data-tip
                    data-for='guardar-enviar'
                    onClick={props.onSaveSend}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='30'
                      height='30'
                      fill='#2A2889'
                      className='bi bi-cursor'
                      viewBox='0 0 16 16'
                    >
                      <path d='M14.082 2.182a.5.5 0 0 1 .103.557L8.528 15.467a.5.5 0 0 1-.917-.007L5.57 10.694.803 8.652a.5.5 0 0 1-.006-.916l12.728-5.657a.5.5 0 0 1 .556.103zM2.25 8.184l3.897 1.67a.5.5 0 0 1 .262.263l1.67 3.897L12.743 3.52 2.25 8.184z' />
                    </svg>
                  </a>
                  <ReactTooltip id='guardar-enviar' place='top' type='info' effect='solid'>
                    Guardar y enviar
                  </ReactTooltip>

                  <a
                    className='btn btn-secondary btn-sm'
                    onClick={() =>
                      // TODO id_contrato: 2, falta parametrizar el id_contrato
                      navigate('/minutas/minutaFood')
                    }
                    data-tip
                    data-for='show'
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='30'
                      height='30'
                      fill='#2A2889'
                      className='bi bi-eye'
                      viewBox='0 0 16 16'
                    >
                      <path d='M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z' />
                      <path d='M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z' />
                    </svg>
                  </a>
                  <ReactTooltip id='show' place='top' type='info' effect='solid'>
                    Vista Edición
                  </ReactTooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
}
interface hederGridProps {
    back?(): void,
    backAll?(): void,
    onEdit?(): void,
    onSave?(): void,
    onSaveSend?(): void,
    onPrintMinuta?(): void,
    onPrintMinutaCliente?(): void,
    onExportMinuta?(): void,
    onExportMinutaCliente?(): void,
}
export { HeaderGrid }